module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/7Kdlbp3m5v5hHQoo39sD6b-886a44bc3e8ad759568cb1f8ea073a6f.jpg";